<template>
<div class="container">
  <div class="main-header" style="margin-top: 50px; margin-bottom: -10px; font-family: 'Zoho Puvi', sans-serif;">
        <!-- <h2 data-aos="fade-up" data-aos-duration="2000"><p style="margin-top: -80px; background-color: white; padding: 0px 15px;"> -->
        <h2><p style="margin-top: -80px; background-color: white; padding: 0px 15px;">
            <span>{{ content.heading }}</span>{{ content.headingRest }}
        </p>
        </h2>
      </div>
        <div class="row justify-content-between align-items-center" style="position: relative;">
            <div class="col-lg-6" style="z-index: 99;">
                <div class="vertical-slider-contianer">
                    <div class="hero__title" id="animatedHeading">
                        <!-- Seven hand-written cards, now one loop. The number
                             in the badge was typed into each card; it is the
                             position in the list, so it is derived here. -->
                        <div class="slick-dupe" v-for="(card, index) in content.cards" :key="card.title">
                            <div class="slider-card hero__title-misc  |  animate-slide">
                                <div class="slider-head">
                                    <span class="service-icon">{{ index + 1 }}</span>
                                    <h3 style="font-family: 'Zoho_Puvi_Bold' !important;">{{ card.title }}</h3>
                                </div>
                                <p style="font-family: 'Zoho_Puvi_Regular' !important;">{{ card.content }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="custom-nav">
                        <span class="prev-btn">
                            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                                <g id="arrow_up_line" fill='none' fill-rule='nonzero'>
                                    <path
                                        d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z' />
                                    <path fill='#09244BFF'
                                        d='M12.707 3.636a1 1 0 0 0-1.414 0L5.636 9.293a1 1 0 1 0 1.414 1.414L11 6.757V20a1 1 0 1 0 2 0V6.757l3.95 3.95a1 1 0 0 0 1.414-1.414l-5.657-5.657Z' />
                                </g>
                            </svg>
                        </span>
                        <span class="next-btn">
                            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                                <g id="arrow_down_line" fill='none' fill-rule='nonzero'>
                                    <path
                                        d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z' />
                                    <path fill='#09244BFF'
                                        d='m11 17.243-3.95-3.95a1 1 0 1 0-1.414 1.414l5.657 5.657a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0-1.414-1.414L13 17.243V4a1 1 0 1 0-2 0v13.243Z' />
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>


            </div>
            <!-- The wrapper is absolutely positioned, so its height never
                 constrained the image; "height: 100px" only misdescribed a box
                 that is really ~600px tall. Left as auto so it matches what it
                 contains. -->
            <div style="width: 65%; height: auto; position: absolute; right: -120px; top: 130px;">
                <!-- <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/index/MEA Slider PNG Image.png" style="width: 100%;"></img> -->
                <!-- <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/home/MEA%20Slider%20PNG%20Image.png" style="width: 100%;"></img> -->
                <!-- height:auto is load-bearing. The width/height attributes act as
                     CSS presentational hints, so `style="width: 100%"` overrode the
                     width hint (1617px -> ~858px) while the height hint stayed pinned
                     at 1128px. The image therefore rendered 858x1128 instead of
                     858x598 — stretched to 1.88x its correct height, which is what
                     made the artwork spill past the section and reappear below the
                     footer. Measured: 1128px before, 599px after. The attributes are
                     kept because they still give the browser the aspect ratio up
                     front, which is what reserves the right box and avoids shift. -->
                <img width="1617" height="1128" loading="lazy" src="https://measiteassetpublic.zohostratus.in/home/MEA%20Slider%20PNG%20Image%20Compressed.png" style="width: 100%; height: auto;"></img>
            </div>
            <!-- <div class="col-lg-5 mt-4 circle-section2">
                <div class="circle-wrapper">
                    <div class="center-circle"><img loading="lazy" src="https://www.zohowebstatic.com/sites/zweb/images/commonroot/zoho-logo-web.svg"
                            alt="Zoho"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://play-lh.googleusercontent.com/kMqYJkxV39D2ZY3fCRSQG0LL1DOEwEmY72QFJXk4B7RYRjcQjzgRRcFUKtQ_bxySrA"
                            alt="kMqYJkxV39D2ZY3fCRSQG0LL1DOEwEmY72QFJXk4B7RYRjcQjzgRRcFUKtQ_bxySrA"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://wpforms.com/wp-content/uploads/cache/integrations/a7222963c3a5d48ad819450ccceb565b.png"
                            alt="a7222963c3a5d48ad819450ccceb565b"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://zoho.codafish.net/wp-content/uploads/2022/08/forms-512-1.png"
                            alt="forms-512-1"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://media.imgcdn.org/repo/2025/01/zoho-show-presentation-maker/678e2eee0edc2-zoho-show-presentation-maker-Icon.webp"
                            alt="678e2eee0edc2-zoho-show-presentation-maker-Icon"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://flow-in-public.nimbuspop.com/flow-apps/zoho_writer.png"
                            alt="zoho_writer"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://zohowebstatic.com/sites/default/files/ogimage/catalyst-logo.png"
                            alt="catalyst-logo"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://d4.alternativeto.net/_z_0w3d4K_1K6oOccVgCFs4uLvC65CHXvJEmd_JkJv8/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy96b2hvLXByb2plY3RzXzIzMTY0MC5wbmc.png"
                            alt="YWJzOi8vZGlzdC9pY29ucy96b2hvLXByb2plY3RzXzIzMTY0MC5wbmc"></div>
                    <div class="zc-icon"><img loading="lazy" src="https://www.roviasolutions.com/https://measiteassetpublic.zohostratus.in/img/zoho/webp/img7.webp"
                            alt="img7"></div>
                </div>
            </div> -->
        </div>

    </div>
</template>

<script>
import homeContent from '@/assets/home-content.json';

export default {
  props: {
    content: {
      type: Object,
      default: () => homeContent.HomeSliderSection
    }
  },
  data() {
    return {
      swiperInstance: null,
    };
  },
  name: "HomeSliderVue",
  mounted() {
    // this.$nextTick(() => {
    //   var titleMain = $("#animatedHeading");
    //     var titleSubs = titleMain.find("slick-active");

    //     if (titleMain.length) {

    //         titleMain.slick({
    //             autoplay: false,
    //             arrows: false,
    //             dots: false,
    //             slidesToShow: 3,
    //             centerPadding: "10px",
    //             draggable: false,
    //             infinite: true,
    //             pauseOnHover: false,
    //             swipe: false,
    //             touchMove: false,
    //             vertical: true,
    //             verticalScrolling: true,
    //             speed: 1500,
    //             autoplaySpeed: 3000,
    //             useTransform: true,
    //             cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    //             adaptiveHeight: true
    //         });

    //         // On init
    //         $(".slick-dupe").each(function (index, el) {
    //             $("#animatedHeading").slick('slickAdd', "<div>" + el.innerHTML + "</div>");
    //         });
    //         titleMain.slick('slickPlay');
    //     };

    //     $(".prev-btn").click(function () {
    //         titleMain.slick("slickPrev");
    //     });

    //     $(".next-btn").click(function () {
    //         titleMain.slick("slickNext");
    //     });

    //     document.addEventListener("DOMContentLoaded", () => {
    //     const section = document.querySelector(".circle-section2");
    //     const wrapper = document.querySelector(".circle-wrapper");

    //     const circleObserver = new IntersectionObserver(entries => {
    //     entries.forEach(entry => {
    //     if (entry.isIntersecting) {
    //     wrapper.classList.add("animate");
    //     }
    //     });
    //     }, { threshold: 0.5 });

    //     circleObserver.observe(section);
    //     });
    // })
  this.$nextTick(() => {
      var titleMain = $("#animatedHeading");
        var titleSubs = titleMain.find("slick-active");

        if (titleMain.length) {

            titleMain.slick({
                autoplay: false,
                arrows: false,
                dots: false,
                slidesToShow: 3,
                centerPadding: "10px",
                draggable: false,
                infinite: true,
                pauseOnHover: false,
                swipe: false,
                touchMove: false,
                vertical: true,
                verticalScrolling: true,
                speed: 1500,
                autoplaySpeed: 6000,
                useTransform: true,
                cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                adaptiveHeight: true
            });

            // On init
            $(".slick-dupe").each(function (index, el) {
                $("#animatedHeading").slick('slickAdd', "<div>" + el.innerHTML + "</div>");
            });
            titleMain.slick('slickPlay');
        };

        $(".prev-btn").click(function () {
            titleMain.slick("slickPrev");
        });

        $(".next-btn").click(function () {
            titleMain.slick("slickNext");
        });

    const section = document.querySelector(".circle-section2");
    const wrapper = document.querySelector(".circle-wrapper");

    const circleObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            wrapper.classList.add("animate");
          } else {
            wrapper.classList.remove("animate");
          }
        });
      },
      { threshold: 0.5 }
    );

    circleObserver.observe(section);

  });

  },
  methods: {
    // goNext() {
    //   if (this.swiperInstance) this.swiperInstance.slideNext();
    // },
    // goPrev() {
    //   if (this.swiperInstance) this.swiperInstance.slidePrev();
    // },
  },
};
</script>

<style scoped>
.slick-dupe {
  background-color: white !important;
}
.slider-card {
  background-color: white !important;
}
.slick-slide {
  background-color: white !important;
}

.prev-btn, .next-btn {
    display: none !important;
}

@-webkit-keyframes shrink {
            0% {
                transform: scale(0.9);
            }

            100% {
                transform: scale(0.9);
                color: grey;

            }
        }

        @keyframes shrink {
            0% {
                transform: scale(0.9);


            }

            100% {
                transform: scale(0.9);
            }
        }

        @-webkit-keyframes grow {
            0% {
                transform: scale(0.9);
                filter: blur(0px);
            }

            100% {
                transform: scale(1);
                filter: blur(0px);
            }
        }

        @keyframes grow {
            0% {
                transform: scale(0.9);
                filter: blur(0px);
            }

            100% {
                transform: scale(1);
                filter: blur(0px);
            }
        }

        .animate-slide {
            transform: translate3d(0, 0, 0);
            perspective: 1000;
            filter: blur(0);
            -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
            -webkit-animation-fill-mode: forwards;
            animation-fill-mode: forwards;
            transform-origin: center left;
            filter: blur(1.5px);

        }

        .animate--shrink,
        .hero__title .slick-current>div {
            -webkit-animation-duration: 1s;
            animation-duration: 1s;
            -webkit-animation-name: shrink;
            animation-name: shrink;
            -webkit-animation-timing-function: "linear";
            animation-timing-function: "linear";

        }

        .animate--expand,
        .no-js .hero__title .slick-dupe:nth-child(2)>div,
        .hero__title .slick-current+.slick-slide>div {
            -webkit-animation-duration: 1s;
            animation-duration: 1s;
            -webkit-animation-timing-function: "linear";
            animation-timing-function: "linear";
            -webkit-animation-name: grow;
            animation-name: grow;
            box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;

            /* box-shadow: 0 8.292px 22.802px -6.219px rgba(24, 39, 75, 0.06), 0 14.51px 66.333px -4.146px rgba(24, 39, 75, 0.06); */
        }

        /* Slider */
        .slick-slider {
            position: relative;
            display: block;
            box-sizing: border-box;
            touch-callout: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            touch-action: pan-y;
            tap-highlight-color: transparent;
            padding-top: 40px;
        }

        .slick-list {
            position: relative;
            overflow: hidden;
            display: block;
            margin: 0;
            padding: 0;
        }


        .slick-slide {
            float: left;
            height: 100%;
            min-height: 1px;
            display: none;
        }

        [dir=rtl] .slick-slide {
            float: right;
        }

        .slick-slide img {
            display: block;
        }

        .slick-slide.slick-loading img {
            display: none;
        }

        .slick-slide.dragging img {
            pointer-events: none;
        }

        .slick-initialized .slick-slide {
            display: block;
        }

        .slick-loading .slick-slide {
            visibility: hidden;
        }

        .slick-vertical .slick-slide {
            display: block;
            height: auto;
            border: 0;
            outline: none;
        }

        .slick-vertical .slick-slide::-moz-selection {
            outline: none !important;
            border: 0 !important;
            box-shadow: none;
        }

        .slick-vertical .slick-slide:focus,
        .slick-vertical .slick-slide:active,
        .slick-vertical .slick-slide::selection {
            outline: none !important;
            border: 0 !important;
            box-shadow: none;
        }

        .slick-arrow.slick-hidden {
            display: none;
        }

        .slick-current {
            position: relative;
        }

        .hero__title {
            padding: 50px 0;
        }

        .hero__title .slick-slide {
            padding: 10px 0;
        }

        .hero__title [aria-hidden] {
            transition: 1s;
        }

        .hero__title .slick-current>span {
            box-sizing: border-box;
            display: block;
        }

        .no-js .hero__title .slick-dupe:nth-child(2)>div {
            padding: 1em;
        }

        .hero__title-misc {
            display: block;
            font-size: 24px;
            font-weight: bold;
            color: grey;
        }

        .slider-card {
            border-radius: 15px;
            border: 2.5px solid #E9E9F7;
            transform: scale(0.9);
            padding: 25px;
            margin-left: 25px;
            background: linear-gradient(108deg, #E4F1FF -21.42%, var(--BG-Color---Sec-White, #F8F9FB) 72%);
        }


        .slider-card .service-icon {
            font-size: 20px;
            display: inline-block;
            width: 50px;
            height: 50px;
            border-radius: 30%;
            background: rgb(255, 255, 255);
            text-align: center;
            line-height: 50px;
            border: 2.5px solid rgba(233, 233, 247, 1);
            position: relative;
            color: #000000;
            box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;
        }



        .slider-card .slider-head {
            display: flex;
            gap: 20px;
            margin-bottom: 15px;
            align-items: center;
            font-family: 'Zoho_Puvi_Bold' !important;
        }

        .slider-card p {
            color: #4E647A !important;
            font-family: 'Zoho_Puvi_Regular' !important;
        }

        .slider-card p {
            font-weight: normal;
            font-size: 16px;
            color: #c3c9d4b0;
            line-height: 1.6;
            margin: 0;
        }

        .slider-card h3 {
            color: rgb(0, 0, 0);
            font-size: 22px;
            font-weight: 550;
            margin: 0;
            margin-bottom: 10px;
            height: inherit;
            padding: 0;
            line-height: 1.4;
            position: relative;
        }

        .custom-nav {
            display: flex;
            flex-direction: column;
            position: absolute;
            gap: 25px;
            top: 50%;
            right: -20%;
            transform: translate(-50%, -50%);
        }

        .circle-wrapper::before,
        .circle-wrapper::after {
            border: 2.5px solid #e9e9f7 !important
        }

        .center-circle::before {
            border: 1.5px solid #e9e9f7;
        }

        .prev-btn,
        .next-btn {
            background: rgb(255, 255, 255) !important;
            height: 50px;
            width: 50px;
            line-height: 45px;
            border-radius: 50%;
            justify-content: center;
            display: flex;
            align-items: center;
            text-align: center;
            border: 1.5px solid rgba(233, 233, 247, 1);
        }

        .prev-btn svg,
        .next-btn svg {
            height: 25px;
            width: 25px;
            object-fit: contain;
        }

        .vertical-slider-contianer {
            position: relative;
        }

        .prev-btn, .next-btn {
    display: none !important;
}
</style>